<div fxLayout="column" fxLayoutAlign="center center" class="avenue-viewer">
  <div fxLayout="row row-wrap" fxLayoutAlign="center center">
    <div fxLayout="column">
      @if (isIosMobile) {
        <div class="upload-input-container">
          @if (stepIndex < 3) {
            <div class="upload-input-text">
              Your video will appear here once you complete step 4. For
              now, click next to continue to the next step.
            </div>
          }
          <div
            class="upload-input-text"
            [ngStyle]="{ display: stepIndex > 3 ? 'block' : 'none' }"
            >
            <video #uploadedVideo class="media-player" controls></video>
          </div>
          <input
            class="upload-input"
            type="file"
            ng2FileSelect
            placeholder=""
            #fileUploader
            [accept]="getMimeTypes()"
            [uploader]="uploader"
            (change)="onUploaderChange($event)"
            (onFileSelected)="fileSelected()"
            />
          @if (stepIndex === 3) {
            <button
              id="file-select-button"
              class="file-select-button"
              mat-raised-button
              color="default"
              (click)="fileUploader.click()"
              >
              <mat-icon>folder_open</mat-icon>
              Select a file or record
            </button>
          }
        </div>
      }
      @if (!isIosMobile) {
        <video
          class="media-player"
          #video
          playsinline
          autoplay
          muted
        ></video>
      }
      @if (showOverlay) {
        <div id="overlay">
          <div class="timer">{{ countdownTimer }}</div>
        </div>
      }
    </div>
    <div
      class="media-assets"
      [ngClass]="{ hideAsset: !showAsset && stepIndex > 0 }"
      >
      @if (performTask?.parentMediaAsset?.performType == 1) {
        <div>
          <img
            class="media-player"
            [src]="mediaUrl$ | async"
            alt="Performance Media Image"
            />
        </div>
      }
      @if (performTask?.parentMediaAsset?.performType == 0) {
        <div>
          <video
            class="media-player"
            #assetVideo
            playsinline
            [src]="mediaUrl$ | async"
          ></video>
        </div>
      }
    </div>
    @if (stepIndex === 0) {
      <div class="media-instructions">
        <p>
          Activity:
          <i>{{ performTask?.displayName }}</i
            >. You will have <i>{{ performTask?.mediaTime }}</i> seconds to
            view a stimulus. You can watch it
            <i>{{ formatMaxAttempts() }}</i
              >. Then, you will have
              <i>{{ performTask?.recordTime }}</i> seconds to record your
              response. You have {{ formatRecordingTries() }}to record.
              Finally, you will rate your performance.
            </p>
          </div>
        }
      </div>

      <ng-template #stepOne>
        <div fxLayout="column" fxLayoutAlign="space-between center">
          <div>Click the button below to begin your activity</div>
        </div>
      </ng-template>

      <ng-template #stepTwo>
        <div fxLayout="column" fxLayoutAlign="space-between center">
          <div
            class="avenue-instructions"
            [innerHTML]="performTask?.description"
          ></div>
          <div class="perform-progress-bar">
            <div class="perform-progress-bar-track"></div>
            <div
              class="perform-progress-bar-fill"
              [ngStyle]="{ width: percentTime + '%' }"
            ></div>
          </div>
        </div>
      </ng-template>

      <ng-template #stepThree>
        <div fxLayout="column" fxLayoutAlign="space-between center">
          <div>
            You have {{ formatViewsRemaining() }}remaining.
            @if (viewsRemaining > 0 || viewsRemaining === -1) {
              <span
                >&nbsp;Would you like to watch it again or continue to
                recording?</span
                >
              }
              @if (viewsRemaining == 0) {
                <span
                  >&nbsp;Click next to continue.</span
                  >
                }
              </div>
            </div>
          </ng-template>

          <ng-template #stepFour>
            <div fxLayout="column" fxLayoutAlign="space-between center">
              <div
                class="avenue-instructions"
                [innerHTML]="performTask?.description"
              ></div>
              @if (!isIosMobile) {
                <div class="perform-progress-bar">
                  <div class="perform-progress-bar-track"></div>
                  <div
                    class="perform-progress-bar-fill"
                    [ngStyle]="{ width: percentTime + '%' }"
                  ></div>
                </div>
              }
              <div class="timeIndicatorContainer">
                <span class="recordingTimeIndicator">{{ recordingTimeIndicator | timerIndicator }}</span>
                <span class="totalRecordingTime">{{ totalRecordingTime | timerIndicator }}</span>
              </div>
            </div>
          </ng-template>

          <ng-template #stepFive>
            <div fxLayout="column" fxLayoutAlign="space-between center">
              <div>
                You have
                @if (recordingTries !== -1) {
                  <span>{{ recordingTries }}</span>
                }
                @if (recordingTries === -1) {
                  <span>unlimited</span>
                }
                @if (recordingTries === 1) {
                  <span> try</span>
                }
                @if (recordingTries !== 1) {
                  <span> tries</span>
                }
                remaining.
                @if (
                  assignment &&
                  (recordingTries > 0 || recordingTries === -1)
                  ) {
                  <span
                    >&nbsp;Would you like to record again or continue?</span
                    >
                  }
                  @if (
                    recordingTries === 0 ||
                    (!assignment && recordingTries === -1)
                    ) {
                    <span
                      >&nbsp;Click next to continue.</span
                      >
                    }
                  </div>
                </div>
              </ng-template>

              <ng-template #stepSix>
                <div fxLayout="column" fxLayoutAlign="space-between center">
                  <div>Rate your performance and leave feedback for your teacher</div>
                  <form
                    novalidate
                    class="feedbackForm"
                    [formGroup]="feedbackForm"
                    fxLayout="column"
                    fxLayoutAlign="center center"
                    fxFlex="100"
                    >
                    <div
                      fxLayout="row wrap"
                      fxLayoutAlign="space-between center"
                      fxFlexFill
                      >
                      <div fxLayout="column" fxFlex="48" fxLayoutAlign="start">
                        <div>My Performance</div>
                        <div style="margin: 8px">
                          <!-- TODO: The 'tickInterval' property no longer exists -->
                          <mat-slider
                            thumbLabel
                            style="width: 100%"
                            max="10"
                            min="0"
                            step="1"
                            formControlName="studentScore"
                            ><input matSliderThumb /><input matSliderThumb />
                          </mat-slider>
                        </div>
                      </div>
                      <div fxLayout="column" fxFlex="48" fxLayoutAlign="start">
                        <div>Comments for My Teacher</div>
                        <mat-form-field class="feedbackForm__studentComments">
                          <label>
                            <input
                              matInput
                              type="text"
                              placeholder=""
                              formControlName="studentComments"
                              />
                          </label>
                          <mat-error
                            print-error
                            [control]="feedbackForm.get('studentComments')"
                            fieldName="Student comments"
                            >
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                  </form>
                  @if (submitClicked) {
                    <mat-progress-bar
                      mode="determinate"
                      value="{{ uploader?.queue[0]?.progress }}"
                    ></mat-progress-bar>
                  }
                </div>
              </ng-template>

              @if (smallScreen) {
                @if (performTask && !errorMsg) {
                  <mat-vertical-stepper
                    linear
                    #stepper
                    (selectionChange)="stepChange($event)"
                    [selectedIndex]="stepIndex"
                    >
                    <mat-step [editable]="false">
                      <ng-template matStepLabel>Introduction</ng-template>
                      <ng-container *ngTemplateOutlet="stepOne"></ng-container>
                      <div
                        class="button-set"
                        fxLayout="row"
                        fxLayoutAlign="center center"
                        >
                        <button mat-raised-button color="primary" matStepperNext>
                          Next
                        </button>
                      </div>
                    </mat-step>
                    <mat-step [editable]="viewsRemaining > 0 || viewsRemaining === -1">
                      <ng-template matStepLabel>View</ng-template>
                      <ng-container *ngTemplateOutlet="stepTwo"></ng-container>
                      <div
                        class="button-set"
                        fxLayout="row"
                        fxLayoutAlign="center center"
                        >
                        <button mat-raised-button color="primary" matStepperNext>
                          Next
                        </button>
                      </div>
                    </mat-step>
                    <mat-step [editable]="false">
                      <ng-template matStepLabel>Review</ng-template>
                      <ng-container *ngTemplateOutlet="stepThree"></ng-container>
                      <div
                        class="button-set"
                        fxLayout="row"
                        fxLayoutAlign="center center"
                        >
                        @if (viewsRemaining > 0 || viewsRemaining === -1) {
                          <button
                            mat-raised-button
                            color="default"
                            matStepperPrevious
                            >
                            <mat-icon>replay</mat-icon>
                          </button>
                        }
                        <button mat-raised-button color="primary" matStepperNext>
                          Next
                        </button>
                      </div>
                    </mat-step>
                    <mat-step [editable]="recordingTries > 0">
                      <ng-template matStepLabel>Record</ng-template>
                      <ng-container *ngTemplateOutlet="stepFour"></ng-container>
                      <div
                        class="button-set"
                        fxLayout="row"
                        fxLayoutAlign="center center"
                        >
                        @if (uploader?.queue?.length > 0 || !isIosMobile) {
                          <button
                            [disabled]="showOverlay"
                            mat-raised-button
                            color="primary"
                            matStepperNext
                            >
                            Next
                          </button>
                        }
                      </div>
                    </mat-step>
                    <mat-step [editable]="false">
                      <ng-template matStepLabel>Retry</ng-template>
                      <ng-container *ngTemplateOutlet="stepFive"></ng-container>
                      <div
                        class="button-set"
                        fxLayout="row"
                        fxLayoutAlign="center center"
                        >
                        @if (recordingTries > 0 || recordingTries === -1) {
                          <button
                            mat-raised-button
                            color="default"
                            matStepperPrevious
                            >
                            Record Again
                          </button>
                        }
                        <button mat-raised-button color="primary" matStepperNext>
                          Continue
                        </button>
                      </div>
                    </mat-step>
                    <mat-step [editable]="false">
                      <ng-template matStepLabel>Feedback</ng-template>
                      <ng-container *ngTemplateOutlet="stepSix"></ng-container>
                      <div
                        class="button-set"
                        fxLayout="row"
                        fxLayoutAlign="center center"
                        >
                        <button
                        [disabled]="
                            submitClicked ||
                            !assignment ||
                            assignment.completedAt
                        "
                          mat-raised-button
                          color="primary"
                          (click)="taskComplete()"
                          >
                          Submit
                        </button>
                      </div>
                    </mat-step>
                  </mat-vertical-stepper>
                }
              } @else {
                @if (performTask && !errorMsg) {
                  <mat-horizontal-stepper
                    linear
                    #stepper
                    linear
                    (selectionChange)="stepChange($event)"
                    [selectedIndex]="stepIndex"
                    >
                    <mat-step [editable]="false">
                      <ng-template matStepLabel>Introduction</ng-template>
                      <ng-container *ngTemplateOutlet="stepOne"></ng-container>
                      <div
                        class="button-set"
                        fxLayout="row"
                        fxLayoutAlign="center center"
                        >
                        <button mat-raised-button color="primary" matStepperNext>
                          Next
                        </button>
                      </div>
                    </mat-step>
                    <mat-step [editable]="viewsRemaining > 0 || viewsRemaining === -1">
                      <ng-template matStepLabel>View</ng-template>
                      <ng-container *ngTemplateOutlet="stepTwo"></ng-container>
                      <div
                        class="button-set"
                        fxLayout="row"
                        fxLayoutAlign="center center"
                        >
                        <button mat-raised-button color="primary" matStepperNext>
                          Next
                        </button>
                      </div>
                    </mat-step>
                    <mat-step [editable]="false">
                      <ng-template matStepLabel>Review</ng-template>
                      <ng-container *ngTemplateOutlet="stepThree"></ng-container>
                      <div
                        class="button-set"
                        fxLayout="row"
                        fxLayoutAlign="center center"
                        >
                        @if (viewsRemaining > 0 || viewsRemaining === -1) {
                          <button
                            mat-raised-button
                            color="default"
                            matStepperPrevious
                            >
                            <mat-icon>replay</mat-icon>
                          </button>
                        }
                        <button mat-raised-button color="primary" matStepperNext>
                          Next
                        </button>
                      </div>
                    </mat-step>
                    <mat-step [editable]="recordingTries > 0 || recordingTries === -1">
                      <ng-template matStepLabel>Record</ng-template>
                      <ng-container *ngTemplateOutlet="stepFour"></ng-container>
                      <div
                        class="button-set"
                        fxLayout="row"
                        fxLayoutAlign="center center"
                        >
                        @if (uploader?.queue?.length > 0 || !isIosMobile && performTask?.allowPause) {
                          <button
                            mat-raised-button
                            [disabled]="disablePause"
                            (click)="togglePause()"
                            [ngClass]="isPaused ? 'record-button' : 'pause-button'"
                            >
                            <mat-icon [ngClass]="isPaused ? 'record-icon' : 'pause-icon'">
                              {{isPaused ? 'radio_button_checked' : 'pause'}}
                            </mat-icon>
                            <a>{{isPaused ? 'Resume' : 'Pause'}}</a>
                          </button>
                        }
                        @if (uploader?.queue?.length > 0 || !isIosMobile) {
                          <button
                            [disabled]="showOverlay"
                            mat-raised-button
                            color="primary"
                            (click)="stopRecording()"
                            matStepperNext
                            >
                            Review Recording
                          </button>
                        }
                      </div>
                    </mat-step>
                    <mat-step [editable]="false">
                      <ng-template matStepLabel>Retry</ng-template>
                      <ng-container *ngTemplateOutlet="stepFive"></ng-container>
                      <div
                        class="button-set"
                        fxLayout="row"
                        fxLayoutAlign="center center"
                        >
                        @if (recordingTries > 0 || recordingTries === -1) {
                          <button
                            mat-raised-button
                            color="default"
                            class="record-again"
                            matStepperPrevious
                            >
                            Record Again
                          </button>
                        }
                        <button mat-raised-button color="primary" matStepperNext>
                          Next
                        </button>
                      </div>
                    </mat-step>
                    <mat-step [editable]="false">
                      <ng-template matStepLabel>Feedback</ng-template>
                      <ng-container *ngTemplateOutlet="stepSix"></ng-container>
                      <div
                        class="button-set"
                        fxLayout="row"
                        fxLayoutAlign="center center"
                        >
                        <button
                        [disabled]="
                            submitClicked ||
                            !assignment ||
                            assignment.completedAt
                        "
                          mat-raised-button
                          color="primary"
                          (click)="taskComplete()"
                          >
                          Submit
                        </button>
                      </div>
                    </mat-step>
                  </mat-horizontal-stepper>
                }
              }

              @if (errorMsg) {
                <div class="error-msg">{{ errorMsg }}</div>
              }
            </div>
